@if (showProgressBar) {
  <mat-progress-bar
    mode="indeterminate"
    color="primary"
  ></mat-progress-bar>
}
<div fxLayout="row" fxLayoutAlign="center none" class="profile-form">
  <form
    (ngSubmit)="submit()"
    novalidate
    [formGroup]="changePasswordForm"
    fxFlex="60"
    fxFlex.lt-md="95"
    fxLayout="column"
    fxLayoutAlign="center stretch"
    >
    <div class="required">Required *</div>

    <div
      formGroupName="passwordGroup"
      fxLayout="column"
      fxLayoutAlign="center"
      >
      <mat-form-field>
        <input
          matInput
          [type]="hide2 ? 'password' : 'text'"
          placeholder="New Password"
          formControlName="newPassword"
          required
          />
        <mat-icon
          id="profile-new-pwd-icon"
          class="profile-pwd-icon"
          matSuffix
          fontSet="fa"
          fontIcon="{{ hide2 ? 'fa-eye-slash' : 'fa-eye' }}"
          (click)="hide2 = !hide2"
          (keyup)="markAsTouched($event)"
          >
        </mat-icon>
        @if (validate('passwordGroup.newPassword', 'required')) {
          <mat-error
            >
            New Password field is required
          </mat-error>
        }
        @if (
          !validate('passwordGroup.newPassword', 'required') &&
          !validate('passwordGroup.newPassword', 'pwdLength') &&
          changePasswordForm.get('passwordGroup.newPassword')
          ?.touched
          ) {
          <mat-error
            >
            Value must be a valid password
          </mat-error>
        }
        @if (
          !validate('passwordGroup.newPassword', 'required') &&
          validate('passwordGroup.newPassword', 'newPassword') &&
          changePasswordForm.get('passwordGroup.newPassword')
          ?.touched
          ) {
          <mat-error
            >
            Value cannot be the same as the old password.
          </mat-error>
        }
      </mat-form-field>
      <mat-chip-listbox>
        <mat-chip-option color="{{ chipColor('pwdLength') }}" selected="true"
          >8-256 Characters</mat-chip-option
          >
        </mat-chip-listbox>

        <mat-form-field>
          <input
            matInput
            [type]="hide3 ? 'password' : 'text'"
            placeholder="Confirm New Password"
            formControlName="confirmPassword"
            required
            />
          <mat-icon
            id="profile-confirm-pwd-icon"
            class="profile-pwd-icon"
            matSuffix
            fontSet="fa"
            fontIcon="{{ hide3 ? 'fa-eye-slash' : 'fa-eye' }}"
            (click)="hide3 = !hide3"
            (keyup)="markAsTouched($event)"
            >
          </mat-icon>
          @if (
            validate('passwordGroup.confirmPassword', 'required')
            ) {
            <mat-error
              >
              Confirm Password field is required
            </mat-error>
          }
          @if (
            changePasswordForm.get('passwordGroup.newPassword')
            ?.value !==
            changePasswordForm.get(
            'passwordGroup.confirmPassword'
            )?.value &&
            changePasswordForm.get('passwordGroup.confirmPassword')
            ?.touched
            ) {
            <mat-error
              >
              Value does not match
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="button-row">
        <!--            <button-->
        <!--                mat-raised-button-->
        <!--                type="button"-->
        <!--                class="button&#45;&#45;cancel"-->
        <!--                (click)="cancel()"-->
        <!--            >-->
        <!--                Cancel-->
      <!--            </button>-->

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="disableUpdateButton()"
        >
        Update Password
      </button>
    </div>
  </form>
</div>
